import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import { Box, Stack, useTheme } from '@mui/material'
import cls from 'classnames'
import { memo } from 'react'

import AddressSpanWithCopyButton from '@/components/base/AddressSpanWithCopyButton'
import { format, formatSafe } from '@/utils/numeric'

import { type TokenListItemProps } from '../types'

const TokenListItem = ({ option, nickName, onClick, balance, balanceUsd }: TokenListItemProps) => {
  const theme = useTheme()
  const isUnknownToken = option.type === 'user' && option.tags && !option.tags.length

  return (
    <Box
      className="w-full flex items-center max-w-full gap-x-2 bg-[#141A23] px-4 py-2 rounded-lg cursor-pointer hover:bg-[#141A23]/60"
      data-testid={cls({
        [`token-picker-${option.symbol}`]: !nickName,
        [`token-picker-${nickName}-${option.symbol}`]: nickName,
      })}
      onClick={() => onClick(option)}
    >
      <Box className="w-[30px] h-[30px] min-w-[30px] relative">
        <Box className={isUnknownToken ? 'opacity-30' : ''}>
          <img
            src={option.logoURI || ''}
            alt={option.name}
            width={30}
            height={30}
            className="w-full h-full rounded-full object-cover"
          />
        </Box>
        {isUnknownToken && (
          <Box className="absolute right-0 bottom-0 text-sm">
            <WarningRoundedIcon htmlColor="#EB5757" fontSize="inherit" />
          </Box>
        )}
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          minWidth: 0,
          '& .token-symbol': {
            color: theme.palette.mode === 'light' ? '#586069' : '#ffffff',
          },
          '& .token-name': {
            color: theme.palette.mode === 'light' ? '#586069' : '#D0D1D8',
          },
          '& .token-address': {
            color: theme.palette.mode === 'light' ? '#586069' : '#D0D1D8',
          },
        }}
      >
        <Stack direction="row" alignItems="center" spacing="5px" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <span className="text-base font-semibold token-symbol">{option.displaySymbol}</span>
            {isUnknownToken && (
              <Box className="bg-[#1E2735] text-xs font-medium px-2 py-1 rounded select-none text-[#9CA3AE]">Unknown</Box>
            )}
          </Stack>
          {balance > 0 && (
            <span className="text-base font-semibold token-balance">
              {formatSafe(balance, option.decimals)}
            </span>
          )}
        </Stack>
        <Box className="flex items-center justify-between">
          <AddressSpanWithCopyButton address={option.address} />
          {balanceUsd > 0 && (
            <span className="text-xs token-balance-usd">${format(balanceUsd)}</span>
          )}
        </Box>
      </Box>
    </Box>
  )
}

const memoTokenListItem = memo(TokenListItem)
memoTokenListItem.displayName = 'TokenListItem'
export default memoTokenListItem
